export const selectDataSet = payload => ({
  type: "SELECT",
  payload,
});
